import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

function ApprovalCategoryDialog({
  open,
  onClose,
  onSubmit,
  editData,
}) {
  const [formValues, setFormValues] = useState({
    id: '',
    label: '',
    displayOrder: 0,
    active: true,
  });

  const [errors, setErrors] = useState({});

  // Populate form when dialog opens in edit mode
  useEffect(() => {
    if (open) {
      if (editData) {
        // Editing mode
        setFormValues({
          id: editData.id || '',
          label: editData.label || '',
          displayOrder:
            editData.displayOrder !== undefined
              ? editData.displayOrder
              : 0,
          active: editData.active,
        });
      } else {
        // Creating mode — clear form
        setFormValues({
          id: '',
          label: '',
          displayOrder: 0,
          active: true,
        });
      }
      setErrors({});
    }
  }, [open, editData]);

  const handleChange = (field, val) => (e) => {
    const newVal = val !== undefined ? val : e?.target?.value
    setFormValues((prev) => ({
      ...prev,
      [field]:
        e?.target?.type === 'number'
          ? parseInt(newVal, 10)
          : newVal,
    }));
  };

  const handleSave = () => {
    const newErrors = {};
    if (!formValues.id) newErrors.id = 'Category ID is required';
    if (!formValues.label) newErrors.label = 'Label is required';
    if (
      formValues.displayOrder === '' ||
      isNaN(formValues.displayOrder)
    )
      newErrors.displayOrder = 'Display order is required';
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    onSubmit(formValues, !!editData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        {editData ? 'Edit Approval Category' : 'Add Approval Category'}
      </DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          fullWidth
          label="Category ID"
          value={formValues.id}
          onChange={handleChange('id')}
          error={!!errors.id}
          helperText={errors.id}
        />

        {/* Label */}
        <TextField
          margin="normal"
          fullWidth
          label="Label"
          value={formValues.label}
          onChange={handleChange('label')}
          error={!!errors.label}
          helperText={errors.label}
        />

        {/* Display Order */}
        <TextField
          type="number"
          margin="normal"
          fullWidth
          label="Display Order"
          value={formValues.displayOrder}
          onChange={handleChange('displayOrder')}
          error={!!errors.displayOrder}
          helperText={errors.displayOrder}
        />

        <div style={{ marginTop: '1rem' }}>
          <label>
            <input
              type="checkbox"
              checked={formValues.active}
              onChange={(e) => {
                const val = e.target.checked
                handleChange('active', val)()
              }}
            />{' '}
            Active
          </label>
        </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {editData ? 'Update' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApprovalCategoryDialog;